import React from "react";
import MasterDetailLayout from "../../../components/layout/MasterDetailLayout";
import PendingDeploymentCompactList from "../components/PendingDeploymentCompactList";

const PendingDeploymentSplitView = () => <MasterDetailLayout list={<PendingDeploymentCompactList />} />;

export default PendingDeploymentSplitView;
